import { httpClient } from "../http/httpClient";

export type Lead = {
  _id: string;
  name: string;
  cpf: string;
  contacted: boolean;
  availableBalance: number;
  phone: string;
  createdAt: string;
  updatedAt: string;
};

export type GetByIdLinkResponse = {
  _id: string;
  name: string;
  label: string;
  seller: string;
  tables: string[];
  leads: Lead[];
  simulations_count: number;
  createdAt: string;
  updatedAt: string;
};

export const getByIdLink = async (linkId: string) => {
  const { data } = await httpClient
    .get<GetByIdLinkResponse>(`/self-hire/${linkId}`)
    .catch((error) => {
      throw error?.response?.data || error;
    });
  return data;
};
